<!-- <template>
    <div class="my-3">
        <div class="row justify-content-center">
            <div v-for="(button, index) in buttons" :key="index" class="col-auto">
                <button @click="button.action" :class="button.class">
                    <i :class="button.icon"></i> {{ button.label }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionButtonsCard",
    props: {
        buttons: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    methods: {
        isButtonDisabled(button) {
            if (typeof button.disabled === "function") {
                return button.disabled();
            }
            return button.disabled === true;
        },
        isButtonLoading(button) {
            if (typeof button.loading === "function") {
                return button.loading();
            }
            return button.loading === true;
        },
    },
};
</script>
 -->
<template>
    <div class="my-3">
        <div class="row justify-content-center">
            <slot> <!-- Permet de personnaliser les boutons si besoin -->
                <div v-for="(button, index) in buttons" :key="index" class="col-auto">
                    <button
                        type="button"
                        @click="button.action"
                        :class="button.class"
                        :disabled="isButtonDisabled(button)"
                        v-if="!button.condition || button.condition()"
                    >
                        <span
                            v-if="isButtonLoading(button)"
                            class="spinner-border spinner-border-sm me-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        <i v-else-if="button.icon" :class="button.icon"></i>
                        {{ button.label }}
                    </button>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionButtonsCard",
    props: {
        buttons: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    methods: {
        isButtonDisabled(button) {
            if (typeof button.disabled === "function") {
                return button.disabled();
            }
            return button.disabled === true;
        },
        isButtonLoading(button) {
            if (typeof button.loading === "function") {
                return button.loading();
            }
            return button.loading === true;
        },
    },
};
</script>
